import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChangePasswordApi, CheckOtpApi, InsertBuildingApi, InsertBuildingDetailApi, SendOtpApi, SetAddressFirstApi, SetCivilRegistryApi, SetNewInformation, ValidateOtpApi, type InsertBuildingData } from "./api.js";
import { SendOtpKey, SetAddressFirstKey, ValidateOtpKey, GetInfoKey, SetCivilRegistryKey, ChangePasswordKey } from "./key.js";
import { useNavigate } from "react-router-dom";
import { toastify } from "../../../components/ui/Toasts/index.js";

export const useSendOtp = () => {
    return useMutation({
        mutationFn: (mobile: string) => SendOtpApi(mobile),
        mutationKey: SendOtpKey(),
    });
};

export const useValidateOtp = () => {
    return useMutation({
        mutationFn: ({ mobile, otpCode }: { mobile: string; otpCode: string }) =>
            ValidateOtpApi(mobile, otpCode),
        mutationKey: ValidateOtpKey(),
    });
};
export const useChangePassword = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: {
            oldPassword: string;
            newPassword: string;
            repeatPass: string;
        }) => ChangePasswordApi(data),
        mutationKey: ChangePasswordKey(),
        onSuccess: (res: any) => {
            // (اختیاری) کش کاربر را invalidate کن
            queryClient.invalidateQueries({ queryKey: GetInfoKey() });
        },
    
    });
};
export const useSetCivilRegistry = () => {
    return useMutation({
        mutationFn: (data: {
            firstName: string;
            lastName: string;
            nationalId: string;
            birthDate: string;
        }) => SetCivilRegistryApi(data),
        mutationKey: SetCivilRegistryKey(),
    });
};
export const useSetAddressFirst = () => {
    return useMutation({
        mutationFn: (data: {
            townshipId: number;
            postalCode: string;
            address: string;
        }) => SetAddressFirstApi(data),
        mutationKey: SetAddressFirstKey(),
    });
};

export const useNewInformation = () => {
    const Navigate = useNavigate();
    const queryClient = useQueryClient();
    const result = useMutation({
        mutationFn: (UserInfomation: any) => SetNewInformation(UserInfomation),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['GetInfo'] });
            Navigate("/market/profile");
        },
      
    });
    return result;
};

export const useInsertBuilding = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: InsertBuildingData) => InsertBuildingApi(data),
        mutationKey: ['InsertBuilding'],
        onSuccess: (data) => {
            if (!data.hasError) {
                queryClient.invalidateQueries({ queryKey: GetInfoKey() });
            }
        },

    });
};

export const useInsertBuildingDetail = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: ({ buildingId, data }: { buildingId: number; data: any }) =>
            InsertBuildingDetailApi(buildingId, data),
        mutationKey: ['InsertBuildingDetail'],

    });
};